<template>
  <section id="home">
    <md-drawer id="drawer" class="md-right" :md-active.sync="showSidepanel">
      <StartupDetails
        :closeSidepanel="closeSidepanel"
        :selectedStartup="selectedStartup"
        v-if="selectedStartup"
      />
      <FideicomisoDetails
        :closeSidepanel="closeSidepanel"
        :fideicomisoData="fideicomisoData"
        v-if="fideicomisoData && !selectedStartup"
      />
    </md-drawer>
    <Header
      :openSidepanel="openSidepanel"
      :totalValuation="totalValuation"
      :startupQuantity="startupQuantity"
      :totalInvested="totalInvested"
      :portfolioValuation="portfolioValuation"
      :totalEmployees="totalEmployees"
      :totalExternalInvested="totalExternalInvested"
      class="header"
    />
    <transition name="slide-fade">
      <StartupItemDisplayer
        :startups="startupsFiltered"
        :openSidepanel="openSidepanel"
        v-if="startups.length > 0"
      />
      <GridxX class="file-icon" v-else />
    </transition>
  </section>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import StartupItemDisplayer from '../components/StartupItemDisplayer.vue';
import StartupDetails from '../components/StartupDetails.vue';
import FideicomisoDetails from '../components/FideicomisoDetails.vue';
import GridxX from '../assets/icons/gridx-x.svg';

export default {
  name: 'Home',
  components: {
    Header,
    StartupItemDisplayer,
    StartupDetails,
    FideicomisoDetails,
    GridxX,
  },
  computed: {
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    startupsFiltered() {
      const a = this.startups.filter(x => {
        if(this.selectedFondo === 'GRIDX2') {
          return x.basic.inversores.some(y => y.name.toUpperCase() === 'GridX - Fund II'.toUpperCase());
        }
        
        return x.basic.inversores.some(y => y.name.toUpperCase() === 'GridX'.toUpperCase());
      });
      return a;
    },
    startupQuantity() {
      return this.startupsFiltered.length;
    },
    totalValuation() {
      return this.startupsFiltered.reduce((x, y) => x + y.basic.valuacion, 0);
    },
    portfolioValuation(){
      return this.startupsFiltered.reduce((x, y) => {
        let gridxInvestor = null;

        if(this.selectedFondo === 'GRIDX2') {
          gridxInvestor = y.basic.inversores.find(x => x.name.toUpperCase() === 'GridX - Fund II'.toUpperCase());
        } else {
          gridxInvestor = y.basic.inversores.find(x => x.name.toUpperCase() === 'GridX'.toUpperCase());
        }

        const gridxPercentage = gridxInvestor ? gridxInvestor.porcentaje_participacion : 100 || 100;
        return x + ((+gridxPercentage * +y.basic.valuacion) / 100);
      }, 0);
    },
    totalInvested() {
      return this.startupsFiltered.reduce((x, y) => {
        let invertido = 0;

        if(this.selectedFondo === 'GRIDX2') {
          invertido = y.basic.invertido_gridx_2 + y.basic.invertido_gridx_2_follow;
        } else {
          invertido = y.basic.invertido_gridx + y.basic.invertido_gridx_follow;
        }

        return x + invertido;
      }, 0);
    },
    totalExternalInvested() {
      return this.startupsFiltered.reduce((x, y) => {
        let invertido = 0;

        if(this.selectedFondo === 'GRIDX2') {
          invertido = y.basic.inversion_externa + y.basic.invertido_gridx + y.basic.invertido_gridx_follow;
        } else {
          invertido = y.basic.inversion_externa + y.basic.invertido_gridx_2 + y.basic.invertido_gridx_2_follow;
        }

        return x + invertido;
      }, 0);
    },
    totalEmployees(){
      return this.startupsFiltered.reduce((x, y) => x + y.basic.empleados, 0);
    },
  },
  watch: {
    showSidepanel(value) {
      this.htmlClassList[value ? 'add' : 'remove']('noscroll');
    },
  },
  data: () => ({
    showSidepanel: false,
    htmlClassList: document.getElementsByTagName('html')[0].classList,
    drawerElem: null,
    startups: [],
    selectedStartup: null,
    fideicomisoData: null,
    fondos: {
      GRIDX: 'invertido_gridx',
      GRIDX2: 'invertido_gridx_2',
    }
  }),
  mounted() {
    this.drawerElem = document.getElementById('drawer');
    this.getStartupData();
  },
  methods: {
    openSidepanel(value = true, startup) {
      this.selectedStartup = startup;
      this.drawerElem.scrollTop = 0;
      this.showSidepanel = value;
    },
    closeSidepanel() {
      this.showSidepanel = false;
    },
    async getStartupData() {
      const token = localStorage.getItem('gridx_app_token');
      if (!token) {
        this.goLogin();
        return;
      }

      this.$store.commit('toggleLoadingBar', true);

      try {
        const formData = new FormData();
        formData.append('email', this.email);
        formData.append('password', this.password);

        const response = await fetch('https://gridxbackend.dreamhosters.com/api/startups/list', {
          method: 'GET',
          headers: {
            'X-AUTH-TOKEN': token,
          },
        });

        if (!response.ok) {
          this.$store.commit('toggleLoadingBar', false);
          localStorage.removeItem('gridx_app_token');
          this.goLogin();
          return;
        }

        const data = await response.json();

        const fideicomiso = await fetch('https://gridxbackend.dreamhosters.com/api/documentos_fideicomiso/list', {
          method: 'GET',
          headers: {
            'X-AUTH-TOKEN': token,
          },
        });

        const fideicomisoData = await fideicomiso.json();

        this.$store.commit('toggleLoadingBar', false);
        this.startups = data.data;
        this.fideicomisoData = fideicomisoData.data;

        const fondos = Array.isArray(data.data[0].user_fondos) ? data.data[0].user_fondos : Object.values(data.data[0].user_fondos);

        this.$store.commit(
          'toggleFondosBar', 
          fondos.length > 1
        );

        if(fondos.length > 0) {
          this.$store.commit('selectFondo', fondos[0]);
        } 
      } catch (e) {
        console.error(e);
        this.$store.commit('toggleLoadingBar', false);
        localStorage.removeItem('gridx_app_token');
        this.goLogin();
      }
    },
    goLogin() {
      localStorage.removeItem('gridx_app_token');
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style scoped lang="scss">
.file-icon {
  max-width: 300px;
  max-height: 300px;
  width: 50vw;
  height: 50vw;
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -12vh);
  opacity: 0.1;

  path {
    stroke: #000;
  }
}

#home {
  background: #f9f6fc;
  min-height: 100vh;
  overflow: hidden;
}

.md-drawer {
  position: fixed;
  max-width: 100vw;
  width: 100vw;
  height: 100vh;
  @media (min-width: 768px) {
    width: 448px;
  }
}
</style>
